import Image from 'next/image';
import styles from './BannerEcommerce.module.scss';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import { axiosInstance } from '../../../utils/axiosInstance';
import { imgPrefix } from '../../../utils';

interface BannerData {
  src: string;
  link: string;
}

export default function BannerEcommerce({
  categoryId,
  categoryName,
  customClassName,
}: {
  categoryId: number;
  categoryName: string;
  customClassName: string;
}) {
  const [src, setSrc] = useState('');
  const [link, setLink] = useState('');
  const [bannerName, setBannerName] = useState('');
  const [isValidImage, setIsValidImage] = useState(false);
  const [checkedImage, setCheckedImage] = useState(false);

  useEffect(() => {
    async function getBannerAttributes() {
      try {
        const requestOptions = {
          url: `${process.env.NEXT_PUBLIC_API_CLIENTS}/v1/category/banner?id=${categoryId}`,
          method: 'GET',
        };

        const { data } = await axiosInstance<BannerData>(requestOptions);

        if (data?.link) setLink(data.link);

        if (data?.src) {
          const path = imgPrefix(`/images/${data.src}`);
          const fileName =
            data.src
              .split('/')
              .pop()
              ?.replace(/\.[^/.]+$/, '') ?? '';
          setBannerName(fileName);

          const res = await fetch(path, { method: 'HEAD' });

          if (res.ok) {
            setSrc(path);
            setIsValidImage(true);
          } else {
            setIsValidImage(false);
          }

          setCheckedImage(true);
        }
      } catch (error) {
        setCheckedImage(true);
      }
    }

    getBannerAttributes();
  }, [categoryId, categoryName]);

  let finalLink = '';

  if (src && link && bannerName) {
    const url = new URL(link, window.location.origin);
    url.searchParams.set('utm_source', 'getninjas_site');
    url.searchParams.set('utm_medium', 'banner');
    url.searchParams.set('utm_campaign', categoryName);
    url.searchParams.set('utm_banner', bannerName);
    finalLink = url.toString();
  }

  if (!checkedImage || !isValidImage || !src || !link) return null;

  return (
    <div className={`${styles['banner-root']} ${styles[customClassName]}`}>
      <Link href={finalLink} target="_blank">
        <Image src={src} alt="Banner de serviços" width={350} height={306} />
      </Link>
    </div>
  );
}
